import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";

const YoutubeLiveStream = ({ onStatusChange }) => {
  const [liveStatus, setLiveStatus] = useState({
    isLive: false,
    videoId: null,
    title: null,
  });
  const [socket, setSocket] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_SOCKET_URL, {
      transports: ["websocket", "polling"], // Prefer websocket
      reconnectionDelayMax: 10000,
      reconnectionAttempts: 5,
      withCredentials: true,
      forceNew: true,
    });

    newSocket.on("connect_error", (err) => {
      setError(err.message);
    });

    setSocket(newSocket);
    setLiveStatus({
      isLive: true,
      videoId: "k4V3Mo61fJM", // Replace with your live stream video ID
      title: "Testing Live Stream",
    });

    return () => newSocket.disconnect();
  }, [onStatusChange]);

  //   return () => newSocket.disconnect();
  // }, [onStatusChange]);

  if (error) {
    return <div className="text-red-500 p-4 text-center">{error}</div>;
  }

  if (!liveStatus.isLive) {
    return null;
  }

  return (
    <div className="w-full max-w-4xl mx-auto p-4">
      {liveStatus.title && (
        <h2 className="text-xl font-bold mb-4">{liveStatus.title}</h2>
      )}
      <div className="relative pt-[56.25%]">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src={`https://www.youtube.com/embed/${liveStatus.videoId}?autoplay=1`}
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      </div>
    </div>
  );
};

export default YoutubeLiveStream;
